import { Inject, Injectable, Optional, inject } from '@angular/core';
import { JsonLdBuilder, SchemaBuilder } from '../../structured-data.model';
import { ProductFacade } from '@boels/shared-state';
import { JSONLD_PRODUCT_BUILDER } from '../../tokens';
import { BOProduct } from '@boels/models';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class ProductSchemaBuilder implements SchemaBuilder {
  private currentProduct = inject(ProductFacade);

  constructor(
    @Optional()
    @Inject(JSONLD_PRODUCT_BUILDER)
    protected builders: JsonLdBuilder<BOProduct>[],
  ) {}

  build(): Observable<any> {
    return this.currentProduct.getCurrentProductAsObservable().pipe(
      switchMap((product: BOProduct | undefined) => {
        if (product) {
          return combineLatest(this.collect(product)).pipe(
            map((res: object[]) => Object.assign({}, ...res)),
          );
        }
        return of({});
      }),
    );
  }

  protected collect(product: BOProduct): Observable<any>[] {
    if (!product || !product.code) {
      return [];
    }
    const builders = this.builders
      ? this.builders.map((builder) => builder.build(product))
      : [];

    return [
      of({
        '@context': 'http://schema.org',
        '@type': 'Product',
      }),
      ...builders,
    ];
  }
}
